import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import iconMultipliers from "../../../assets/images/iconMultipliers.svg";
import GhaBidsViewer from "./ghaBidsViewer";
import KayakBidsViewer from "./kayakBidsViewer";

const BidsViewer = ({ page, idAccount, platform }) => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const platformChannelId = platform[0]?.channel_id;

    const isGhaPlatform =
        page === "metaSearch" &&
        platform.length === 1 &&
        (platformChannelId === "GHA_META" || platformChannelId === "GHA_PPA");

    const isKayakPlatform =
        page === "metaSearch" &&
        platform.length === 1 &&
        (platformChannelId === "KAYAK");

    return (
        <>
            {(isGhaPlatform || isKayakPlatform) && (
                <Tooltip title={isKayakPlatform ? "Kayak Bidding" : `GHA Active Multipliers`}>
                <IconButton sx={{ padding: "4px", "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.12)" } }} onClick={() => setIsPanelOpen(true)}>
                        <img src={iconMultipliers} alt="Multipliers" style={{ width: 19, height: 17 }} />
                    </IconButton>
                </Tooltip>
            )}

            {isGhaPlatform && (
                <GhaBidsViewer
                    isOpen={isPanelOpen}
                    onClose={() => setIsPanelOpen(false)}
                    idAccount={idAccount}
                    platform={platformChannelId}
                />
            )}

            {isKayakPlatform && (
                <KayakBidsViewer
                    isOpen={isPanelOpen}
                    onClose={() => setIsPanelOpen(false)}
                    idAccount={idAccount}
                    platform={platformChannelId}
                />
            )}
        </>
    );
};

export default BidsViewer;
